import { IconButton } from 'lib/button';
import { Card } from 'lib/card';
import { transitionAnimation, typographyCaption } from 'lib/core';
import { IconEdit } from 'lib/icons';
import { InlineInput, StyledBaseInputField } from 'lib/input';
import { IndeterminateProgressCircle } from 'lib/loader';
import { Menu } from 'lib/menu';
import { TitleOnTruncate } from 'lib/truncation';

import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
  max-width: calc(100% - 32px);
`;

/* TEXT STYLED CONTAINERS */
export const StyledTextContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.color.additional.light.value};
  border: none;
  color: ${({ theme }) => theme.color.additional.dark.value};
  display: flex;
  flex-direction: row;
  max-width: 100%;
  min-height: 24px;
  width: max-content;
  &:hover {
    border-radius: ${({ theme }) => theme.size.borderRadius.small.value};
    cursor: pointer;
    margin-left: -4px;
    outline: 1px solid ${({ theme }) => theme.color.gray[300].value};
    padding-left: ${({ theme }) => theme.size.spacing.small.value};
    svg {
      display: flex;
      min-width: 16px;
    }
  }
`;

export const StyledTruncatedText = styled(TitleOnTruncate)`
  background-color: ${({ theme }) => theme.color.additional.light.value};
  color: ${({ theme }) => theme.color.additional.dark.value};
  padding-right: 4px;
`;

export const StyledPlaceholderText = styled(TitleOnTruncate)`
  background-color: ${({ theme }) => theme.color.additional.light.value};
  color: ${({ theme }) => theme.color.additional.dark.value};
  padding-right: 4px;
  font-weight: 300;
`;

export const StyledEditIconWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.gray[300].value};
  border-radius: 0 3px 3px 0;
`;

export const StyledEditIcon = styled(IconEdit)`
  background-color: ${({ theme }) => theme.color.gray[300].value};
  border-radius: 0 3px 3px 0;
  display: none;
  padding: ${({ theme }) => theme.size.spacing.small.value};
`;

/* INPUT STYLED CONTAINERS */
export const StyledInputContainer = styled.div`
  max-width: 100%;
  position: relative;
`;

export const StyledInlineInput = styled(InlineInput)`
  display: flex;
  ${StyledBaseInputField} {
    cursor: ${({ $isSaving }) => $isSaving && 'not-allowed'};
  }
  label {
    border-radius: ${({ theme }) => theme.size.borderRadius.small.value};
    flex-direction: row-reverse;
    height: 24px;
    max-width: 100%;
    outline: none;
    padding-left: ${({ theme }) => theme.size.spacing.small.value};
    width: 100%;
  }
`;

export const StyledInlineInputForDropdown = styled(InlineInput)`
  display: flex;
  ${StyledBaseInputField} {
    border-radius: 0;
    cursor: ${({ $isSaving }) => ($isSaving ? 'not-allowed' : 'pointer')};
    caret-color: ${({ theme }) => theme.color.additional.light.value};
  }
  label {
    border-radius: ${({ theme }) => theme.size.borderRadius.small.value};
    flex-direction: row-reverse;
    height: 24px;
    max-width: 100%;
    outline: none;
    padding-left: ${({ theme }) => theme.size.spacing.small.value};
    padding-right: 0;
    width: 100%;
  }
`;

export const StyledIndeterminateProgressCircle = styled(IndeterminateProgressCircle)`
  max-height: 20px;
  max-width: 20px;
  padding: 0;
`;

/* THE DROPDOWN BUTTONS CONTAINERS AND SUCH */
export const StyledButtonContainer = styled(Card)`
  ${transitionAnimation('opacity')};
  display: flex;
  flex-direction: row;
  height: 32px;
  justify-content: space-between;
  margin-top: 5px;
  opacity: ${({ $areButtonsShown }) => ($areButtonsShown ? 1 : 0)};
  padding: 4px;
  position: absolute;
  right: 0;
  width: 60px;
  visibility: ${({ $areButtonsShown, $isSaving }) => ($isSaving || !$areButtonsShown ? 'hidden' : 'visible')};
`;

export const StyledSaveCancelIconButton = styled(IconButton)`
  border-radius: ${({ theme }) => theme.size.borderRadius.small.value};
  height: 24px;
  min-height: 24px;
  min-width: 24px;
  width: 24px;
`;

export const StyledErrorMessage = styled.div`
  ${({ theme }) => typographyCaption(theme)}
  color: ${({ theme }) => theme.color.system.negative[500].value};
  float: left;
  font-size: ${({ theme }) => theme.font.size.caption.value};
  margin-left: ${({ theme }) => theme.size.spacing.small.value};
  margin-right: 68px;
  margin-top: ${({ theme }) => theme.size.spacing.small.value};
  min-width: calc(100% - 68px);
`;

/* Styled Dropdown Components */
export const StyledDropdownContainer = styled.div`
  position: relative;
`;
